import { render, staticRenderFns } from "./checkYS.vue?vue&type=template&id=6382b12d&scoped=true&"
import script from "./checkYS.vue?vue&type=script&lang=js&"
export * from "./checkYS.vue?vue&type=script&lang=js&"
import style0 from "./checkYS.vue?vue&type=style&index=0&id=6382b12d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382b12d",
  null
  
)

export default component.exports